
import React from 'react';
import "./Empresa.css"; 



function SalesDist() {
  return (
    <div className="containerSales">
      <div className="sales-block">
        <img src="images/MachRang.png" alt="Machinery Range" />
        <img src="images/capacidadeMaq.gif" alt="Machine Capacity" />
      </div>
      <div className="sales-block">
        <img src="images/DistVendas.png" alt="Sales Distribution" />
        <img src="images/DistVend2.gif" alt="Sales Distribution 2" />
      </div>
    </div>
  );
}


export default SalesDist;